<section id="campaign-enquire" class="row campaign-enquire">
  <div class="col-xs-10 col-lg-10 col-lg-offset-1 col-xs-offset-1">
    <div class="row">
      <div class="col-lg-offset-1 col-lg-4 enquire-now-section">
        <app-enquire-now-form [profileType]="profileType">
        </app-enquire-now-form>
      </div>
      <div class="col-lg-offset-1 col-lg-5 campaign-enquire-description">
        <div>
          <h2 class="heading">finzy is happy to help!</h2>
          <div class="support-contact">
            Call us : {{profileType === ProfileType.IFA ? '9341 800 800' : '9341 300 300'}} <br/>
            Email us : {{profileType === ProfileType.IFA ? 'partners@finzy.com' : 'support@finzy.com'}}
          </div>
        </div>
        <div >
          <span class="support-contact">Click for </span>
          <a class="download-btn"(click)=downloadLOC()>     Our Recovery Partners List</a>
        </div>
        <div style="margin-top: 10px;">
          <span class="support-contact">Click for </span>
          <a class="download-btn" (click)=downloadLSP()>    Our Digital Lending Partners List</a>
        </div>

      </div>
    </div>
  </div>
</section>
